import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessSignOffService {

  constructor(private http: HttpClient) { }

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    }),
    withCredentials: true
  };

  private buildFormData(params: any): string {
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        formData.set(key, params[key].toString());
      }
    });
    return formData.toString();
  }

  // Load sign-off list - action_id=31304
  getSignOffList(baseUrl: string, filterParams: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=31304`;
    return this.http.post<any>(url, this.buildFormData(filterParams), this.httpOptions);
  }

  // Save sign-off comment / toggle
  saveSignOffCmt(baseUrl: string, params: any): Observable<any> {
    const url = `${baseUrl}/saveBusinessSignOff`;
    return this.http.post<any>(url, this.buildFormData(params), this.httpOptions);
  }
}
